/**
 * Login page copy (brief deliverable 14), verbatim. `retryAfterMessage` rounds the server's
 * `retryAfterSeconds` up to whole minutes, with "1 minute" written singular.
 */
export const MESSAGES = {
  documentTitle: 'Sign in — Campaign Codex',
  heading: 'Sign in to Campaign Codex',
  usernameLabel: 'Username',
  passwordLabel: 'Password',
  submit: 'Sign in',
  submitPending: 'Signing in…',
  emptyUsername: 'Enter your username.',
  emptyPassword: 'Enter your password.',
  wrongCredentials: "That username and password don't match.",
  networkError: "Can't reach the server. Check that Campaign Codex is running, then try again.",
  expiredSession: 'Your session has ended. Sign in again.',
} as const;

/** "Too many attempts. Try again in N minutes." — N is `retryAfterSeconds` rounded up to a minute. */
export function retryAfterMessage(retryAfterSeconds: number): string {
  const minutes = Math.max(1, Math.ceil(retryAfterSeconds / 60));
  const unit = minutes === 1 ? 'minute' : 'minutes';
  return `Too many attempts. Try again in ${minutes} ${unit}.`;
}
